import { getVIPMemberInfo, getMyVIPSettings, getMemberVipProgress, getVIPBonusInfo } from '@pm/super-library-2/modules/myvip';

import { myVipConstant } from '../constant';

export const myVipAction = {
    checkVipTabIsEnabled,
    initialVipLevelInfo,
    updateHasPendingClaim,
    updateVipBonusInfo,
    fetchVipBonusInfo,
    fetchVipProgress,
};

let vipBonusInfoRequest = null;

function initialVipLevelInfo() {
    return (dispatch, getState) => {
        return new Promise((resolve, reject) => {
            const { language } = getState();
            try {
                getVIPMemberInfo(language.countryLanguageKey)
                    .then((res) => {
                        dispatch({
                            type: myVipConstant.UPDATE_VIP_LEVEL_INFO,
                            payload: res,
                        });
                        resolve(res);
                    })
                    .catch((error) => {
                        console.error('Error getting VIP level:', error);
                        reject(error);
                    });
            } catch (err) {
                console.error('Error:', err);
                reject(err);
            }
        });
    };
}
function checkVipTabIsEnabled() {
    return (dispatch) => {
        return new Promise(function (resolve, reject) {
            try {
                getMyVIPSettings()
                    .then((data) => {
                        if (data) {
                            dispatch({
                                type: myVipConstant.CHECK_VIP_TAD_IS_ENABLED,
                                payload: data,
                            });
                            dispatch(initialVipLevelInfo());
                            resolve(data);
                        } else {
                            resolve(false);
                        }
                    })
                    .catch(() => {
                        reject(false);
                    });
            } catch (e) {
                reject(false);
            }
        });
    };
}
function updateHasPendingClaim(data) {
    return (dispatch) => {
        dispatch({
            type: myVipConstant.UPDATE_HAS_PENDING_CLAIM,
            payload: data,
        });
    };
}
function updateVipBonusInfo(data) {
    return (dispatch) => {
        dispatch({
            type: myVipConstant.UPDATE_VIP_BONUS_INFO,
            payload: data,
        });
    };
}

function fetchVipBonusInfo(payload = {}) {
    return async (dispatch, getState) => {
        const cachedBonusInfo = getState().myVip?.member?.bonusInfo;

        if (!payload?.force && Array.isArray(cachedBonusInfo) && cachedBonusInfo.length > 0) {
            return cachedBonusInfo;
        }

        if (vipBonusInfoRequest) {
            return vipBonusInfoRequest;
        }

        dispatch({ type: myVipConstant.SET_FETCH_VIP_BONUS_INFO_STATUS, payload: 'loading' });

        vipBonusInfoRequest = getVIPBonusInfo()
            .then((res) => {
                const bonusInfo = Array.isArray(res) ? res : [];
                dispatch(updateVipBonusInfo(bonusInfo));
                return bonusInfo;
            })
            .finally(() => {
                vipBonusInfoRequest = null;
                dispatch({ type: myVipConstant.SET_FETCH_VIP_BONUS_INFO_STATUS, payload: 'complete' });
            });

        return vipBonusInfoRequest;
    };
}

function fetchVipProgress(payload = {}) {
    return async (dispatch, getState) => {
        const state = getState();

        const { language, languageReducer, myVip } = state;
        const requestLanguage = payload?.language || languageReducer?.currentLanguage?.countryLanguageKey || language?.countryLanguageKey;

        if (myVip.fetchVipProgressStatus === 'loading') {
            return;
        }
        dispatch({ type: myVipConstant.SET_FETCH_VIP_PROGRESS_STATUS, payload: 'loading' });
        try {
            const res = await getMemberVipProgress({ language: requestLanguage });
            dispatch({ type: myVipConstant.SET_VIP_PROGRESS, payload: res });
        } finally {
            dispatch({ type: myVipConstant.SET_FETCH_VIP_PROGRESS_STATUS, payload: 'complete' });
        }
    };
}
